import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $createParagraphNode,
  $insertNodes,
  createCommand,
  COMMAND_PRIORITY_EDITOR,
} from 'lexical';
import { $createColumnContainerNode } from '../nodes/ColumnContainerNode';
import { $createColumnNode } from '../nodes/ColumnNode';

export const INSERT_COLUMN_LAYOUT_COMMAND = createCommand('INSERT_COLUMN_LAYOUT_COMMAND');

export default function ColumnLayoutPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_COLUMN_LAYOUT_COMMAND,
      (payload) => {
        const { columnCount } = payload;
        editor.update(() => {
          const container = $createColumnContainerNode(columnCount);
          for (let i = 0; i < columnCount; i++) {
            const column = $createColumnNode();
            column.append($createParagraphNode());
            container.append(column);
          }
          $insertNodes([container]);
        });
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
